import React from 'react';

interface ModulePlaceholderProps {
  moduleName: string;
  description: string;
  endpoint: string;
}

export const ModulePlaceholder: React.FC<ModulePlaceholderProps> = ({
  moduleName,
  description,
  endpoint
}) => {
  return (
    <div className="module-placeholder">
      <h1>{moduleName}</h1>
      <div className="placeholder-content">
        <p className="description">{description}</p>
        <div className="api-info">
          <strong>API Endpoint:</strong>
          <code>{endpoint}</code>
        </div>
        <div className="status-message">
          🚧 This feature is under development
        </div>
      </div>
    </div>
  );
};
